import React from 'react';
import { useInView } from 'react-intersection-observer';

import { useUpdateCurrentValue } from '../../../components/circular-progress/useUpdateValue';
import { DEFAULT_OBSERVER_OPTIONS } from '../../../constants/ovserver';

export const MessageBubbleSvg = ({ ...props }) => {
  const { ref, inView } = useInView(DEFAULT_OBSERVER_OPTIONS);
  const { animatedValue, isAnimated } = useUpdateCurrentValue({
    shouldAnimate: inView,
    value: 15,
    animationSpeed: 100,
    increment: 1
  });

  const time = isAnimated ? '15' : animatedValue;

  return (
    <svg
      {...props}
      ref={ref}
      id="uuid-89fb165a-8ba0-4604-8dc1-dcb75f83d2df"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 320 320"
    >
      <rect width="320" height="320" fill="none" strokeWidth="0" />
      <path
        d="m160,60.184h0c-2.57,0-4.654-2.084-4.654-4.654v-16.607c0-2.57,2.084-4.654,4.654-4.654h0c2.57,0,4.654,2.084,4.654,4.654v16.607c0,2.57-2.084,4.654-4.654,4.654Zm45.629-3.02l3.941-9.555c.61-1.479-.094-3.172-1.573-3.782h0c-1.479-.61-3.172.094-3.782,1.573l-3.941,9.555c-.61,1.479.094,3.172,1.573,3.782h0c1.479.61,3.172-.094,3.782-1.573Zm35.952,25.303l7.298-7.319c1.129-1.133,1.127-2.967-.006-4.096h0c-1.133-1.129-2.967-1.127-4.096.006l-7.298,7.319c-1.129,1.133-1.127,2.967.006,4.096h0c1.133,1.129,2.967,1.127,4.096-.006Zm23.532,37.136l9.543-3.969c1.477-.614,2.176-2.31,1.562-3.787h0c-.614-1.477-2.31-2.176-3.787-1.562l-9.543,3.969c-1.477.614-2.176,2.31-1.562,3.787h0c.614,1.477,2.31,2.176,3.787,1.562Zm-2.09,86.212l9.555,3.941c1.479.61,3.172-.094,3.782-1.573h0c.61-1.479-.094-3.172-1.573-3.782l-9.555-3.941c-1.479-.61-3.172.094-3.782,1.573h0c-.61,1.479.094,3.172,1.573,3.782Zm-25.304,35.952l7.319,7.298c1.133,1.129,2.967,1.127,4.096-.006h0c1.129-1.133,1.127-2.967-.006-4.096l-7.319-7.298c-1.133-1.129-2.967-1.127-4.096.006h0c-1.129,1.133-1.127,2.967.006,4.096Zm-37.135,23.532l3.969,9.543c.614,1.477,2.31,2.176,3.787,1.562h0c1.477-.614,2.176-2.31,1.562-3.787l-3.969-9.543c-.614-1.477-2.31-2.176-3.787-1.562h0c-1.477.614-2.176,2.31-1.562,3.787Zm-86.212-2.09l-3.941,9.555c-.61,1.479.094,3.172,1.573,3.782h0c1.479.61,3.172-.094,3.782-1.573l3.941-9.555c.61-1.479-.094-3.172-1.573-3.782h0c-1.479-.61-3.172.094-3.782,1.573Zm-35.952-25.302l-7.298,7.319c-1.129,1.133-1.127,2.967.006,4.096h0c1.133,1.129,2.967,1.127,4.096-.006l7.298-7.319c1.129-1.133,1.127-2.967-.006-4.096h0c-1.133-1.129-2.967-1.127-4.096.006Zm-23.531-37.137l-9.543,3.969c-1.477.614-2.176,2.31-1.562,3.787h0c.614,1.477,2.31,2.176,3.787,1.562l9.543-3.969c1.477-.614,2.176-2.31,1.562-3.787h0c-.614-1.477-2.31-2.176-3.787-1.562Zm2.09-86.212l-9.555-3.941c-1.479-.61-3.172.094-3.782,1.573h0c-.61,1.479.094,3.172,1.573,3.782l9.555,3.941c1.479.61,3.172-.094,3.782-1.573h0c.61-1.479-.094-3.172-1.573-3.782Zm25.303-35.951l-7.319-7.298c-1.133-1.129-2.967-1.127-4.096.006h0c-1.129,1.133-1.127,2.967.006,4.096l7.319,7.298c1.133,1.129,2.967,1.127,4.096-.006h0c1.129-1.133,1.127-2.967-.006-4.096Zm37.136-23.532l-3.969-9.543c-.614-1.477-2.31-2.176-3.787-1.562h0c-1.477.614-2.176,2.31-1.562,3.787l3.969,9.543c.614,1.477,2.31,2.176,3.787,1.562h0c1.477-.614,2.176-2.31,1.562-3.787Zm45.237,226.003v-16.607c0-2.57-2.084-4.654-4.654-4.654h0c-2.57,0-4.654,2.084-4.654,4.654v16.607c0,2.57,2.084,4.654,4.654,4.654h0c2.57,0,4.654-2.084,4.654-4.654Zm-109.124-125.731h-16.607c-2.57,0-4.654,2.084-4.654,4.654h0c0,2.57,2.084,4.654,4.654,4.654h16.607c2.57,0,4.654-2.084,4.654-4.654h0c0-2.57-2.084-4.654-4.654-4.654Zm225.547,0h-16.607c-2.57,0-4.654,2.084-4.654,4.654h0c0,2.57,2.084,4.654,4.654,4.654h16.607c2.57,0,4.654-2.084,4.654-4.654h0c0-2.57-2.084-4.654-4.654-4.654Z"
        fill="#c74ef4"
        strokeWidth="0"
      />
      <path
        d="m200.5,218.167h0c15.464,0,28-12.536,28-28v-60c0-15.464-12.536-28-28-28h-81c-15.464,0-28,12.536-28,28v60c0,15.464,12.536,28,28,28h30.155l5.43,9.872c1.529,2.781,5.024,3.796,7.805,2.267.955-.525,1.742-1.311,2.267-2.267l5.43-9.872h29.913Z"
        fill="#fff"
        strokeWidth="0"
      />
      <path
        d="m149.332,183.123l3.006,8.838h.036l2.844-8.838h3.978v12.852h-2.646v-9.108h-.036l-3.15,9.108h-2.178l-3.15-9.018h-.036v9.018h-2.646v-12.852h3.978,0Zm15.249,0v12.852h-2.825v-12.852h2.825Zm5.368,0l5.364,8.621h.036v-8.621h2.646v12.852h-2.826l-5.346-8.604h-.036v8.604h-2.646v-12.852h2.808Z"
        fill="#132f1d"
        strokeWidth="0"
      />
      <g>
        <text
          transform="translate(131.221 174.285)"
          fill="#132f1d"
          fontFamily="Poppins-Bold, Poppins"
          fontSize="60"
          fontWeight="700"
        >
          <tspan x="0" y="0">
            {time}
          </tspan>
        </text>
      </g>
    </svg>
  );
};
